export const downloadAppURL = {
  ios: 'https://apps.apple.com/kr/app/%ED%94%8C%EB%A3%A8%EB%B0%94-%EB%A7%88%EC%BC%93/id6447500132',
  android: 'https://play.google.com/store/apps/details?id=com.gintlab.pluvamarket',
};
